import { render, staticRenderFns } from "./EnterIdNumber.vue?vue&type=template&id=64a06d28"
import script from "./EnterIdNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./EnterIdNumber.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports